export const Sortable = (superclass) => class extends superclass {
  actsAsSortable(sortingEnabled) {
    if (!sortingEnabled) {
      return;
    }

    this._sortCallbacks = {
      before: [],
      after: []
    };
  }

  sort(sortCriteria) {
    this._runSortCallbacks('before');

    this.list.sort(sortCriteria.sort, {
      order: sortCriteria.order
    });

    this._runSortCallbacks('after');
  }

  beforeSort(callback) {
    this._sortCallbacks.before.push(callback);
  }

  afterSort(callback) {
    this._sortCallbacks.after.push(callback);
  }

  _runSortCallbacks(kind) {
    let data = {
      sortBy: this.menu.sortCriteria.sort
    };

    this._sortCallbacks[kind].forEach(function (callback) {
      callback(data);
    });
  }
};
